import * as React from "react";
import { connect } from "react-redux";
import Login from "../../screens/Login";
import { login, logOut } from "./action";
export interface Props {
  logins: any;
}

export interface State {}
class LoginContainer extends React.Component<Props, State> {
  render() {
    return (
      <Login
        logins={this.props.logins}
        logoutaction={this.props.logoutaction}
        //showAlert={this.props.showAlert}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    logins: (value) => {
      // console.log("index============", value);
      dispatch(login(value));
    },
  };
}
const mapStateToProps = (state) => {
  return {
    //showAlert: state.LoginReducer.showAlert,
  };
};

export default connect(mapStateToProps, bindAction)(LoginContainer);
